// extracted by mini-css-extract-plugin
export default {"userCardWrapperGrid":"UserCardWrapper_userCardWrapperGrid__YD8HZ","userCardWrapperFlex":"UserCardWrapper_userCardWrapperFlex__mqO0K"};